import { type SelectOption } from '../../../../../components';
import { LANGUAGE_QUALIFICATION_TEST_TYPE } from '../constants';
import { PAGE_TEXT } from '../lang';

export const languageQualificationTestTypeOptions: SelectOption[] = [
  {
    value: LANGUAGE_QUALIFICATION_TEST_TYPE.IELTS,
    label:
      PAGE_TEXT.QUALIFICATION.LANGUAGE_QUALIFICATION.OPTIONS_LABEL
        .LANGUAGE_QUALIFICATION_TEST_TYPE.IELTS,
  },
  {
    value: LANGUAGE_QUALIFICATION_TEST_TYPE.TOEFL,
    label:
      PAGE_TEXT.QUALIFICATION.LANGUAGE_QUALIFICATION.OPTIONS_LABEL
        .LANGUAGE_QUALIFICATION_TEST_TYPE.TOEFL,
  },
];
